import generateID from '../reducer/generateID';
import { BASE_URL } from '../urls';
import pako from 'pako';

export const CREATE_TRANSLATION = "CREATE_TRANSLATION";
export const SAVE_CAT_TRANSLATION = "SAVE_CAT_TRANSLATION";
export const SAVE_Q_TRANSLATION = "SAVE_Q_TRANSLATION";
export const FETCHING_TRANSLATION = "FETCHING_TRANSLATION";
export const FETCHED_TRANSLATION = "FETCHED_TRANSLATION";
export const SAVE_TR_FOR_RESPONSE = "SAVE_TR_FOR_RESPONSE"
export const SAVE_TR_METADATA = "SAVE_TR_METADATA";

const TRANSLATION_ENDPOINT = `${BASE_URL}/translation`;

export const createTranslation = (props) => {
  return {
    type: CREATE_TRANSLATION,
    title: props.title,
    id: props.id
  }
}

export const saveCategoryTranslation = (trID, catTrArr) => {
  return {
    type: SAVE_CAT_TRANSLATION,
    trID: trID,
    catTrArr: catTrArr
  }
}

export const saveQuestionTranslation = (trID, props) => {
  return {
    type: SAVE_Q_TRANSLATION,
    trID: trID,
    props: props
  }
}

export const saveTranslationMetadata = (trID, props) => {
  return {
    type: SAVE_TR_METADATA,
    trID: trID,
    props: props
  }
}

export const updateTrForResponse = (trID, responseID) => {
  return {
    type: SAVE_TR_FOR_RESPONSE,
    trID: trID,
    responseID: responseID
  }
}

export function fetchTranslation(id) {
  return (dispatch, getState) => {
    if(id === -1){
      return -1;
    }
    dispatch({
      type: FETCHING_TRANSLATION
    });
    return fetch(TRANSLATION_ENDPOINT + "/" + id)
      .then((response) => {
        return response.json()
          .then((json) => {
            if (json.compressed) {
              let unencodedString = atob(json.compressed);
              let deflatedStringStore = pako.inflate(unencodedString, {to: 'string'});
              json = JSON.parse(deflatedStringStore);
              //BJS TODO: remove once saving persists
              //json.translationList = [] // [{id: 2, title:"Spanish", published: false, updatedAt: (new Date()).getTime()}, {id:3, title:"French", published: false, updatedAt: (new Date()).getTime()}];
            }
            dispatch({
              type: FETCHED_TRANSLATION,
              payload: json
            });
            Promise.resolve();
          });
      });
  }
}
